import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=71c1efbe&scoped=true"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=71c1efbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1efbe",
  null
  
)

export default component.exports